import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/it';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { ref, get } from 'firebase/database';
import { database } from '../firebase/config';
import '../styles/Calendario.css';
import PulsantiCondivisionePDF from './PulsantiCondivisionePDF';
import { ProgrammaPDF } from './ProgrammiLavoro';
import { formattaData } from '../utils/dateUtils';


moment.locale('it');
const localizer = momentLocalizer(moment);

const COLORI_DIPENDENTI = [
  '#667eea', '#764ba2', '#f093fb', '#4facfe',
  '#43e97b', '#fa709a', '#fee140', '#30cfd0',
  '#a8edea', '#ff6a88', '#feca57', '#48dbfb'
];

function CalendarioProgrammi({ vistaIniziale = 'month', onVistaCambiata }) {
  const [eventi, setEventi] = useState([]);
  const [programmi, setProgrammi] = useState([]);
  const [dipendenti, setDipendenti] = useState([]);
  const [veicoli, setVeicoli] = useState([]);
  const [cantieri, setCantieri] = useState([]);
  const [clienti, setClienti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [filtroDipendente, setFiltroDipendente] = useState('');
  const [coloriDipendenti, setColoriDipendenti] = useState({});
  const [vistaCorrente, setVistaCorrente] = useState(vistaIniziale);
  const [dataCorrente, setDataCorrente] = useState(new Date());

  useEffect(() => {
    caricaDati();
  }, []);

  useEffect(() => {
    if (programmi.length > 0 && dipendenti.length > 0) {
      creaEventi();
    }
  }, [programmi, dipendenti, cantieri, veicoli, clienti, coloriDipendenti, filtroDipendente]);


  async function caricaDati() {
    try {
      const [dipSnap, veicSnap, cantSnap, cliSnap, progSnap] = await Promise.all([
        get(ref(database, 'dipendenti')),
        get(ref(database, 'veicoli')),
        get(ref(database, 'cantieri')),
        get(ref(database, 'clienti')),
        get(ref(database, 'programmi-lavorativi'))
      ]);

      const dipendentiData = dipSnap.exists() 
        ? Object.keys(dipSnap.val()).map(key => ({ id: key, ...dipSnap.val()[key] }))
        : [];
      
      const veicoliData = veicSnap.exists()
        ? Object.keys(veicSnap.val()).map(key => ({ id: key, ...veicSnap.val()[key] }))
        : [];
      
      const cantieriData = cantSnap.exists()
        ? Object.keys(cantSnap.val()).map(key => ({ id: key, ...cantSnap.val()[key] }))
        : [];
      
      const clientiData = cliSnap.exists()
        ? Object.keys(cliSnap.val()).map(key => ({ id: key, ...cliSnap.val()[key] }))
        : [];
      
      const programmiData = progSnap.exists()
        ? Object.keys(progSnap.val()).map(key => ({ id: key, ...progSnap.val()[key] }))
        : [];

      setDipendenti(dipendentiData);
      setVeicoli(veicoliData);
      setCantieri(cantieriData);
      setClienti(clientiData);
      setProgrammi(programmiData);

      const colori = {};
      dipendentiData.forEach((dip, index) => {
        colori[dip.id] = COLORI_DIPENDENTI[index % COLORI_DIPENDENTI.length];
      });
      setColoriDipendenti(colori);

      setLoading(false);
    } catch (error) {
      console.error('Errore caricamento dati:', error);
      setLoading(false);
    }
  }

  function creaEventi() {
    const eventiCalendario = programmi
      .filter(prog => !filtroDipendente || prog.dipendenteId === filtroDipendente)
      .map(prog => {
        const dipendente = dipendenti.find(d => d.id === prog.dipendenteId);
        const cantiere = cantieri.find(c => c.id === prog.cantiereId);
        const veicolo = veicoli.find(v => v.id === prog.veicoloId);

        const [anno, mese, giorno] = prog.data.split('-');
        const [oreInizio, minutiInizio] = prog.orarioInizio.split(':');
        const [oreFine, minutiFine] = prog.orarioFine.split(':');

        const start = new Date(anno, mese - 1, giorno, oreInizio, minutiInizio);
        const end = new Date(anno, mese - 1, giorno, oreFine, minutiFine);

        return {
          id: prog.id,
          title: dipendente 
            ? `${dipendente.nome} ${dipendente.cognome} - ${cantiere?.luogo || 'N/D'}`
            : 'Programma',
          start: start,
          end: end,
          resource: {
            programma: prog,
            dipendente: dipendente,
            cantiere: cantiere,
            veicolo: veicolo,
            colore: coloriDipendenti[prog.dipendenteId] || '#667eea'
          }
        };
      });

    setEventi(eventiCalendario);
  }

  function handleSelectEvent(event) {
    setSelectedEvent(event);
    setShowModal(true);
  }

  function eventStyleGetter(event) {
    const backgroundColor = event.resource.colore;
    return {
      style: {
        backgroundColor: backgroundColor,
        borderRadius: '5px',
        opacity: 0.9,
        color: 'white',
        border: '0px',
        display: 'block',
        fontWeight: '600',
        fontSize: '13px'
      }
    };
  }

  function handleNavigate(newDate) {
    setDataCorrente(newDate);
  }

  // AGENDA CUSTOM
  function renderAgendaCustom() {
    const eventiOrdinati = [...eventi].sort((a, b) => b.start - a.start);
    
    // Raggruppa per data
    const eventiPerData = {};
    eventiOrdinati.forEach(evento => {
      const dataKey = moment(evento.start).format('YYYY-MM-DD');
      if (!eventiPerData[dataKey]) {
        eventiPerData[dataKey] = [];
      }
      eventiPerData[dataKey].push(evento);
    });

    return (
      <div className="agenda-custom">
        {Object.keys(eventiPerData).length === 0 ? (
          <div className="agenda-empty">
            <p>📅 Nessun programma nel periodo selezionato</p>
          </div>
        ) : (
          Object.keys(eventiPerData).sort((a, b) => b.localeCompare(a)).map(dataKey => (
            <div key={dataKey} className="agenda-gruppo">
              {/* DATA COME INTESTAZIONE */}
              <div className="agenda-data-header">
                📅 {moment(dataKey).format('dddd D MMMM YYYY')}
              </div>
              
              {/* LISTA EVENTI DEL GIORNO */}
              <div className="agenda-eventi-lista">
                {eventiPerData[dataKey].map(evento => (
                  <div 
                    key={evento.id} 
                    className="agenda-evento-riga"
                    onClick={() => handleSelectEvent(evento)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="agenda-evento-orario">
                      ⏰ {moment(evento.start).format('HH:mm')} - {moment(evento.end).format('HH:mm')}
                    </div>
                    <div 
                      className="agenda-evento-dettagli"
                      style={{ 
                        borderLeft: `4px solid ${evento.resource.colore}`,
                        paddingLeft: '15px'
                      }}
                    >
                      <strong>{evento.title}</strong>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    );
  }

  const messages = {
    allDay: 'Tutto il giorno',
    previous: '←',
    next: '→',
    today: 'Oggi',
    month: 'Mese',
    week: 'Settimana',
    day: 'Giorno',
    agenda: 'Agenda',
    date: 'Data',
    time: 'Ora',
    event: 'Programma',
    noEventsInRange: 'Nessun programma in questo periodo',
    showMore: (total) => `+${total} altri`
  };

  if (loading) {
    return (
      <div className="calendario-container">
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <h2>⏳ Caricamento calendario...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="calendario-container">
      <div className="calendario-header">
        <h2>📅 Calendario Programmi Lavorativi</h2>
        
        <div className="vista-buttons">
          <button 
            className={vistaCorrente === 'month' ? 'vista-btn active' : 'vista-btn'}
            onClick={() => { setVistaCorrente('month'); onVistaCambiata?.(); }}
          >
            📅 Mese
          </button>
          <button 
            className={vistaCorrente === 'week' ? 'vista-btn active' : 'vista-btn'}
            onClick={() => { setVistaCorrente('week'); onVistaCambiata?.(); }}
          >
            📆 Settimana
          </button>
          <button 
            className={vistaCorrente === 'day' ? 'vista-btn active' : 'vista-btn'}
            onClick={() => { setVistaCorrente('day'); onVistaCambiata?.(); }}
          >
            📋 Giorno
          </button>
          <button 
            className={vistaCorrente === 'agenda' ? 'vista-btn active' : 'vista-btn'}
            onClick={() => { setVistaCorrente('agenda'); onVistaCambiata?.(); }}
          >
            📝 Agenda
          </button>
        </div>

        <div className="calendario-filtri">
          <label>👤 Filtra per dipendente:</label>
          <select 
            value={filtroDipendente} 
            onChange={(e) => setFiltroDipendente(e.target.value)}
            className="filtro-select"
          >
            <option value="">Tutti i dipendenti</option>
            {dipendenti.map(dip => (
              <option key={dip.id} value={dip.id}>
                {dip.nome} {dip.cognome}
              </option>
            ))}
          </select>
        </div>

        <div className="calendario-legenda">
          <strong>Dipendenti:</strong>
          {dipendenti.map(dip => (
            <span key={dip.id} className="legenda-item">
              <span 
                className="legenda-colore" 
                style={{ backgroundColor: coloriDipendenti[dip.id] }}
              ></span>
              {dip.nome} {dip.cognome}
            </span>
          ))}
        </div>
      </div>

      <div className="calendario-wrapper">
        {vistaCorrente === 'agenda' ? (
          renderAgendaCustom()
        ) : (
          <Calendar
            localizer={localizer}
            events={eventi}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 'calc(100vh - 400px)', minHeight: '500px' }}
            messages={messages}
            eventPropGetter={eventStyleGetter}
            onSelectEvent={handleSelectEvent}
            view={vistaCorrente}
            onView={setVistaCorrente}
            date={dataCorrente}
            onNavigate={handleNavigate}
            views={['month', 'week', 'day']}
            step={30}
            showMultiDayTimes
            popup
            culture="it"
          />
        )}
      </div>

      {showModal && selectedEvent && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content evento-modal" onClick={(e) => e.stopPropagation()}>
            <h3 style={{ 
              background: selectedEvent.resource.colore, 
              color: 'white', 
              padding: '15px', 
              margin: '-30px -30px 20px -30px',
              borderRadius: '10px 10px 0 0'
            }}>
              📋 Dettagli Programma
            </h3>

            <div className="evento-dettaglio">
              <div className="dettaglio-row">
                <span className="dettaglio-label">📅 Data:</span>
                <span className="dettaglio-value">
                  <strong>{moment(selectedEvent.start).format('dddd D MMMM YYYY')}</strong>
                </span>
              </div>

              <div className="dettaglio-row">
                <span className="dettaglio-label">⏰ Orario:</span>
                <span className="dettaglio-value">
                  {moment(selectedEvent.start).format('HH:mm')} - {moment(selectedEvent.end).format('HH:mm')}
                  <span style={{ marginLeft: '10px', color: '#666' }}>
                    ({selectedEvent.resource.programma.durataLavoro})
                  </span>
                </span>
              </div>

              <div className="dettaglio-row">
                <span className="dettaglio-label">👤 Dipendente:</span>
                <span className="dettaglio-value">
                  {selectedEvent.resource.dipendente?.nome} {selectedEvent.resource.dipendente?.cognome}
                </span>
              </div>

              <div className="dettaglio-row">
                <span className="dettaglio-label">🏗️ Cantiere:</span>
                <span className="dettaglio-value">
                  {selectedEvent.resource.cantiere?.luogo || 'N/D'}
                </span>
              </div>

              <div className="dettaglio-row">
                <span className="dettaglio-label">🏢 Cliente:</span>
                <span className="dettaglio-value">
                  {(() => {
                    const cliente = clienti.find(c => c.id === selectedEvent.resource.cantiere?.clienteId);
                    return cliente?.ragioneSociale || 'N/D';
                  })()}
                </span>
              </div>

              <div className="dettaglio-row">
                <span className="dettaglio-label">🚚 Veicolo:</span>
                <span className="dettaglio-value">
                  {selectedEvent.resource.veicolo 
                    ? `${selectedEvent.resource.veicolo.marca} ${selectedEvent.resource.veicolo.modello} (${selectedEvent.resource.veicolo.targa})`
                    : 'N/D'}
                </span>
              </div>

              {selectedEvent.resource.programma.note && (
                <div className="dettaglio-row" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                  <span className="dettaglio-label">📝 Note:</span>
                  <span className="dettaglio-value" style={{ 
                    marginTop: '5px', 
                    padding: '10px', 
                    background: '#fff3cd', 
                    borderRadius: '5px',
                    width: '100%'
                  }}>
                    {selectedEvent.resource.programma.note}
                  </span>
                </div>
              )}
            </div>

            <div className="modal-buttons" style={{ marginTop: 20, justifyContent: 'space-between' }}>
  {/* PDF a sinistra */}
  {(() => {
    const prog = selectedEvent.resource.programma;
    const dip = selectedEvent.resource.dipendente;
    const veic = selectedEvent.resource.veicolo;
    const cant = selectedEvent.resource.cantiere;
    const cli = clienti.find(c => c.id === cant?.clienteId);
    return dip && veic && cant && cli ? (
      <PulsantiCondivisionePDF
        documentoPDF={
          <ProgrammaPDF
            programma={prog}
            dipendente={dip}
            veicolo={veic}
            cantiere={cant}
            cliente={cli}
          />
        }
        nomeFile={`programma-${prog.data}-${dip.cognome}.pdf`}
        testoCondivisione={`Programma Lavorativo ${formattaData(prog.data)} - ${dip.nome} ${dip.cognome} - ${cant.luogo}`}
        emailDestinatario=""
        oggettoEmail={`Programma Lavorativo - ${prog.data} - ${dip.cognome}`}
        corpoEmail={`Programma del ${formattaData(prog.data)}.\n${dip.nome} ${dip.cognome}\n${cant.luogo} - ${cli.ragioneSociale}\n${prog.orarioInizio} - ${prog.orarioFine}\n${prog.durataLavoro}\n${prog.note || 'Nessuna nota'}`}
      />
    ) : null;
  })()}
  {/* Chiudi a destra */}
  <button className="btn-cancel" onClick={() => setShowModal(false)}>Chiudi</button>
</div>

          </div>
        </div>
      )}
    </div>
  );
}

export default CalendarioProgrammi;
